import { render, staticRenderFns } from "./AscentiAppointmentsHeader.vue?vue&type=template&id=c2237de6&scoped=true"
import script from "./AscentiAppointmentsHeader.vue?vue&type=script&lang=js"
export * from "./AscentiAppointmentsHeader.vue?vue&type=script&lang=js"
import style0 from "./AscentiAppointmentsHeader.vue?vue&type=style&index=0&id=c2237de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2237de6",
  null
  
)

export default component.exports